var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","loading":_vm.loading},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.navigate}})}
var staticRenderFns = []

export { render, staticRenderFns }